import Vue from 'vue'
import Router, { isNavigationFailure } from 'vue-router'
import Study from '@/views/study/Study.vue'
import Exam from '@/views/Exam.vue'
import ExamList from '@/views/ExamList.vue'
import ExamPlanDetail from '@/views/ExamPlanDetail.vue'
import ViolationList from '@/views/ViolationList.vue'
import CourseDetail from '@/views/course/CourseDetail.vue'
import CourseList from '@/views/course/CourseList.vue'
import CoursePurchase from '@/views/course/CoursePurchase.vue'
import PaperPurchase from '@/views/paper/PaperPurchase.vue'
import CoursePayment from '@/views/course/CoursePayment.vue'
import ProjectDetail from '@/views/course/ProjectDetail.vue'
import ClassList from '@/views/class/ClassList.vue'
import ClassDetail from '@/views/class/ClassDetail.vue'
import ProductPayment from '@/views/mall/ProductPayment.vue'
import Certification from '@/views/Certification.vue'
import CertificationCategoryDetail from '@/views/CertificationCategoryDetail.vue'
import Employment from '@/views/Employment.vue'

import MyCourses from '@/views/myCourses/MyCourses.vue'
import MemberCenter from '@/views/MemberCenter.vue'
import ExamDetail from '@/views/myCourses/exam/ExamDetail.vue'
import ExamIntro from '@/views/myCourses/ExamIntro.vue'
import PracticeDetail from '@/views/myCourses/exam/PracticeDetail.vue'
import ErrorNotes from '@/views/myCourses/ErrorNotes.vue'
import PaperAnswerResult from '@/views/myCourses/PaperAnswerResult.vue'
import MyExams from '@/views/myCourses/MyExams.vue'
import MyOrders from '@/views/myCourses/MyOrders.vue'
import Coupons from '@/views/myCourses/Coupons.vue'
import Address from '@/views/myCourses/Address.vue'
import ExamSubmitResult from '@/views/myCourses/ExamSubmitResult.vue'
import ExamSubmitSuccess from '@/views/myCourses/ExamSubmitSuccess.vue'
import Simulation from '@/views/myCourses/Simulation.vue'
import Withdraw from '@/views/myCourses/Withdraw.vue'
import Messages from '@/views/myCourses/Messages.vue'
import Settings from '@/views/myCourses/Settings.vue'
import Projects from '@/views/myCourses/Projects.vue'
import MyCertificates from '@/views/myCourses/MyCertificates.vue'
import OrderDetail from '@/views/myCourses/OrderDetail.vue'
import PhysicalOrderPayment from '@/views/PhysicalOrderPayment.vue'
import UserAgreement from '@/views/agreement/UserAgreement.vue'
import Cart from '@/views/Cart.vue'
import CartCheckout from '@/views/CartCheckout.vue'
// Footer pages
import AboutUs from '@/views/footer/AboutUs.vue'
import AboutTalentPlan from '@/views/footer/AboutTalentPlan.vue'
import CompanyQualification from '@/views/footer/CompanyQualification.vue'
import AgreementPage from '@/views/footer/AgreementPage.vue'
import HelpCenter from '@/views/footer/HelpCenter.vue'
import Sitemap from '@/views/footer/Sitemap.vue'

const shouldBuildMobile = process.env.VUE_APP_BUILD_MOBILE !== 'false'

function isMobileUA() {
  if (typeof navigator === 'undefined') return false
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi|MicroMessenger|QQBrowser|UCBrowser|baidubrowser|MiuiBrowser|HuaweiBrowser|Quark/i.test(navigator.userAgent)
}

function isMobileScreen() {
  return typeof window !== 'undefined' && window.innerWidth < 768
}

// 开发环境强制使用移动端视图，便于 H5 调试与走查
const isMobile = shouldBuildMobile && (process.env.NODE_ENV === 'development' || isMobileUA() || isMobileScreen())

const MobilePage = shouldBuildMobile ? require('@/mobile/MobilePage.vue').default : null
Vue.use(Router)

// 解决导航重复点击错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (!isNavigationFailure(err)) {
      throw err
    }
  })
}

// 同样修复replace方法
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (!isNavigationFailure(err)) {
      throw err
    }
  })
}

function isMobileDevice() {
  return isMobileUA() || isMobileScreen()
}

function isLoggedIn() {
  return !!localStorage.getItem('token')
}

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'index',
      component: isMobile ? MobilePage : () => import('@/views/index.vue'),
      meta: {
        title: '首页',
        hidden: false,
        pcView: () => import('@/views/index.vue'),
        mobileView: () => import('@/mobile/MobileIndex.vue'),
        mobileTabbar: true
      }
    },
    {
      path: '/search',
      name: 'search',
      component: isMobile ? MobilePage : () => import('@/views/search/Search.vue'),
      meta: { title: '搜索结果', hidden: true, pcView: () => import('@/views/search/Search.vue'), mobileView: () => import('@/mobile/MobileSearch.vue'), mobileTabbar: true }
    },
    {
      path: '/study',
      name: 'study',
      component: isMobile ? MobilePage : Study,
      meta: { title: '学习', hidden: false, pcView: Study, mobileView: () => import('@/mobile/MobileStudy.vue'), mobileTabbar: true }
    },
    {
      path: '/exam',
      name: 'exam',
      component: isMobile ? MobilePage : Exam,
      meta: { title: '考试', hidden: false, pcView: Exam, mobileView: () => import('@/mobile/MobileExamList.vue'), mobileTabbar: true }
    },
    {
      path: '/exam-list',
      name: 'examList',
      component: isMobile ? MobilePage : ExamList,
      meta: { title: '考试列表', hidden: false, pcView: ExamList, mobileView: () => import('@/mobile/MobileExamList.vue'), mobileNav: true }
    },
    {
      path: '/violation-list',
      name: 'violationList',
      component: isMobile ? MobilePage : ViolationList,
      meta: { title: '违规通知', hidden: false, pcView: ViolationList, mobileView: () => import('@/mobile/MobileExamList.vue'), mobileNav: true }
    },
    {
      path: '/certification',
      name: 'certification',
      component: isMobile ? MobilePage : Certification,
      meta: { title: '职业认证', hidden: false, pcView: Certification, mobileView: () => import('@/mobile/MobileCertification.vue'), mobileTabbar: true }
    },
    {
      path: '/certification-category/:id',
      name: 'certificationCategoryDetail',
      component: isMobile ? MobilePage : CertificationCategoryDetail,
      meta: { title: '认证类别详情', hidden: false, pcView: CertificationCategoryDetail, mobileView: () => import('@/mobile/MobileCertification.vue'), mobileNav: true }
    },
    {
      path: '/employment',
      name: 'employment',
      component: isMobile ? MobilePage : Employment,
      meta: { title: '就业服务', hidden: false, pcView: Employment, mobileView: () => import('@/mobile/MobileEmployment.vue'), mobileTabbar: true }
    },
    {
      path: '/employment-guide/:id',
      name: 'employmentGuideDetail',
      component: isMobile ? () => import('@/mobile/MobileEmploymentGuideDetail.vue') : () => import('@/views/EmploymentGuideDetail.vue'),
      meta: { title: '就业详情', hidden: true, pcView: () => import('@/views/EmploymentGuideDetail.vue'), mobileView: () => import('@/mobile/MobileEmploymentGuideDetail.vue'), mobileNav: true }
    },
    {
      path: '/enterprise/:id',
      name: 'enterpriseDetail',
      component: isMobile ? () => import('@/mobile/MobileEnterpriseDetail.vue') : () => import('@/views/EnterpriseDetail.vue'),
      meta: { title: '企业详情', hidden: true, pcView: () => import('@/views/EnterpriseDetail.vue'), mobileView: () => import('@/mobile/MobileEnterpriseDetail.vue'), mobileTabbar: false }
    },
    {
      path: '/mobile-login',
      name: 'mobileLogin',
      component: isMobile ? MobilePage : () => import('@/views/index.vue'),
      meta: { title: '登录', hidden: true, pcView: () => import('@/views/index.vue'), mobileView: () => import('@/mobile/MobileLogin.vue'), mobileNav: true }
    },
    {
      path: '/wechat-callback',
      name: 'wechatCallback',
      component: isMobile ? MobilePage : () => import('@/views/index.vue'),
      meta: { title: '微信登录', hidden: true, pcView: () => import('@/views/index.vue'), mobileView: () => import('@/mobile/MobileWechatCallback.vue'), mobileNav: true }
    },
    {
      path: '/mobile-register',
      name: 'mobileRegister',
      component: isMobile ? MobilePage : () => import('@/views/index.vue'),
      meta: { title: '注册', hidden: true, pcView: () => import('@/views/index.vue'), mobileView: () => import('@/mobile/MobileRegister.vue'), mobileNav: true }
    },
    {
      path: '/change-password',
      name: 'changePassword',
      component: isMobile ? MobilePage : () => import('@/views/myCourses/Settings.vue'),
      meta: { title: '修改密码', hidden: true, pcView: () => import('@/views/myCourses/Settings.vue'), mobileView: () => import('@/mobile/MobileChangePassword.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/change-phone',
      name: 'changePhone',
      component: isMobile ? MobilePage : () => import('@/views/myCourses/Settings.vue'),
      meta: { title: '修改手机号', hidden: true, pcView: () => import('@/views/myCourses/Settings.vue'), mobileView: () => import('@/mobile/MobileChangePhone.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/change-email',
      name: 'changeEmail',
      component: isMobile ? MobilePage : () => import('@/views/myCourses/Settings.vue'),
      meta: { title: '修改邮箱', hidden: true, pcView: () => import('@/views/myCourses/Settings.vue'), mobileView: () => import('@/mobile/MobileChangeEmail.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/real-name',
      name: 'realName',
      component: isMobile ? MobilePage : () => import('@/views/myCourses/Settings.vue'),
      meta: { title: '实名认证', hidden: true, pcView: () => import('@/views/myCourses/Settings.vue'), mobileView: () => import('@/mobile/MobileRealName.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/course/:id',
      name: 'course',
      component: isMobile ? MobilePage : CourseDetail,
      meta: { title: '课程详情', hidden: false, pcView: CourseDetail, mobileView: () => import('@/mobile/MobileCourseDetail.vue'), mobileNav: true }
    },
    {
      path: '/courses',
      name: 'courseList',
      component: isMobile ? MobilePage : CourseList,
      meta: { title: '所有课程', hidden: false, pcView: CourseList, mobileView: () => import('@/mobile/MobileCourseList.vue'), mobileNav: true }
    },
    {
      path: '/course-purchase/:id',
      name: 'coursePurchase',
      component: isMobile ? MobilePage : CoursePurchase,
      meta: { title: '课程购买', hidden: false, pcView: CoursePurchase, mobileView: () => import('@/mobile/MobileCoursePurchase.vue'), mobileNav: true }
    },
    {
      path: '/classes',
      name: 'classList',
      component: isMobile ? MobilePage : ClassList,
      meta: { title: '所有班级', hidden: false, pcView: ClassList, mobileView: () => import('@/mobile/MobileClassList.vue'), mobileNav: true }
    },
    {
      path: '/class/:id',
      name: 'classDetail',
      component: isMobile ? MobilePage : ClassDetail,
      meta: { title: '班级详情', hidden: false, pcView: ClassDetail, mobileView: () => import('@/mobile/MobileClassDetail.vue'), mobileNav: true }
    },
    {
      path: '/class-purchase/:id',
      name: 'classPurchase',
      component: isMobile ? MobilePage : () => import('@/views/class/ClassPurchase.vue'),
      meta: { title: '班级购买', hidden: false, pcView: () => import('@/views/class/ClassPurchase.vue'), mobileView: () => import('@/mobile/MobileClassPurchase.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/paper-purchase/:id',
      name: 'paperPurchase',
      component: isMobile ? MobilePage : PaperPurchase,
      meta: { title: '试卷购买', hidden: false, pcView: PaperPurchase, mobileView: () => import('@/mobile/MobilePaperPurchase.vue'), mobileNav: true }
    },
    {
      path: '/study-machine-purchase/:id',
      name: 'studyMachinePurchase',
      component: isMobile ? MobilePage : () => import('@/views/mall/ProductPurchase.vue'),
      meta: { title: '学习机购买', hidden: false, pcView: () => import('@/views/mall/ProductPurchase.vue'), mobileView: () => import('@/mobile/MobileStudyMachinePurchase.vue'), mobileNav: true }
    },
    {
      path: '/product-purchase/:id',
      name: 'productPurchase',
      component: isMobile ? MobilePage : () => import('@/views/mall/ProductPurchase.vue'),
      meta: { title: '商品购买', hidden: false, pcView: () => import('@/views/mall/ProductPurchase.vue'), mobileView: () => import('@/mobile/MobileProductDetail.vue'), mobileNav: true }
    },
    {
      path: '/purchase-confirm/:type/:id',
      name: 'purchaseConfirm',
      component: isMobile ? MobilePage : () => import('@/views/common/PurchaseConfirm.vue'),
      meta: { title: '确认订单', hidden: true, pcView: () => import('@/views/common/PurchaseConfirm.vue'), mobileView: () => import('@/views/common/PurchaseConfirm.vue'), requiresAuth: true }
    },
    {
      path: '/payment/:id',
      name: 'payment',
      component: isMobile ? MobilePage : CoursePayment,
      meta: { title: '购买课程', hidden: false, pcView: CoursePayment, mobileView: () => import('@/mobile/MobileCoursePayment.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/product-payment/:id',
      name: 'productPayment',
      component: isMobile ? MobilePage : ProductPayment,
      meta: { title: '购买商品', hidden: false, pcView: ProductPayment, mobileView: () => import('@/mobile/MobileCourseDetail.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/project-detail/:id',
      name: 'projectDetail',
      component: isMobile ? MobilePage : ProjectDetail,
      meta: { title: '项目详情', hidden: false, pcView: ProjectDetail, mobileView: () => import('@/mobile/MobileCourseDetail.vue'), mobileNav: true }
    },
    {
      path: '/product/:id',
      name: 'productDetail',
      component: isMobile ? MobilePage : () => import('@/views/mall/ProductDetail.vue'),
      meta: { title: '商品详情', hidden: false, pcView: () => import('@/views/mall/ProductDetail.vue'), mobileView: () => import('@/mobile/MobileProductDetail.vue'), mobileNav: false }
    },
    {
      path: '/learn/:id',
      name: 'learn',
      component: isMobile ? MobilePage : () => import('@/views/study/StudyLearn.vue'),
      meta: {
        title: '学习页面',
        hidden: false,
        pcView: () => import('@/views/study/StudyLearn.vue'),
        mobileView: () => import('@/mobile/MobileStudyLearn.vue'),
        requiresAuth: false
      }
    },
    {
      path: '/my-courses',
      name: 'myCourses',
      redirect: '/member-center/courses'
    },
    {
      path: '/member-center',
      name: 'memberCenter',
      component: isMobile ? MobilePage : MemberCenter,
      meta: { title: '个人中心', hidden: false, pcView: MemberCenter, mobileView: () => import('@/mobile/MobileUserCenter.vue'), mobileTabbar: true, mobileDrawer: false, requiresAuth: true },
      redirect: isMobile ? '/member-center/home' : '/member-center/courses',
      children: [
        {
          path: 'home',
          name: 'memberHome',
          component: MemberCenter,
          meta: { title: '个人中心', hidden: false, mobileTabbar: true, mobileDrawer: false, mobileView: () => import('@/mobile/MobileUserCenter.vue'), mobileNav: false }
        },
        {
          path: 'exams',
          name: 'memberExams',
          component: MyExams,
          meta: { title: '我的考试', hidden: false, mobileTabbar: false, mobileDrawer: false, mobileView: () => import('@/mobile/MobileMyExams.vue'), mobileNav: true }
        },
        {
          path: 'error-notes',
          name: 'memberErrorNotes',
          component: ErrorNotes,
          meta: { title: '错题记录', hidden: false, mobileTabbar: false, mobileDrawer: false, mobileView: () => import('@/mobile/MobileErrorNotes.vue'), mobileNav: true }
        },
        {
          path: 'coupons',
          name: 'memberCoupons',
          component: Coupons,
          meta: { title: '优惠券', hidden: false, mobileTabbar: false, mobileDrawer: false, mobileView: () => import('@/mobile/MobileCoupons.vue'), mobileNav: true }
        },
        {
          path: 'orders',
          name: 'memberOrders',
          component: MyOrders,
          meta: { title: '我的订单', hidden: false, mobileTabbar: false, mobileDrawer: false, mobileView: () => import('@/mobile/MobileMyOrders.vue'), mobileNav: true }
        },
        {
          path: 'address',
          name: 'memberAddress',
          component: Address,
          meta: { title: '地址管理', hidden: false, mobileTabbar: false, mobileDrawer: false, mobileView: () => import('@/mobile/MobileAddress.vue'), mobileNav: true }
        },
        {
          path: 'simulation',
          name: 'memberSimulation',
          component: Simulation,
          meta: { title: '模拟练习', hidden: false, mobileTabbar: false, mobileDrawer: false, mobileView: () => import('@/mobile/MobileSimulation.vue'), mobileNav: true }
        },
        {
          path: 'messages',
          name: 'memberMessages',
          component: Messages,
          meta: { title: '站内信', hidden: false, mobileTabbar: false, mobileDrawer: false, mobileView: () => import('@/mobile/MobileMessages.vue'), mobileNav: true }
        },
        {
          path: 'settings',
          name: 'memberSettings',
          component: Settings,
          meta: { title: '个人设置', hidden: false, mobileTabbar: false, mobileDrawer: false, mobileView: () => import('@/mobile/MobileSettings.vue'), mobileNav: true }
        },
        {
          path: 'projects',
          name: 'memberProjects',
          component: Projects,
          meta: { title: '我的项目', hidden: false, mobileTabbar: false, mobileDrawer: false, mobileView: () => import('@/mobile/MobileProjects.vue'), mobileNav: true }
        },
        {
          path: 'certificates',
          name: 'memberCertificates',
          component: MyCertificates,
          meta: { title: '我的证书', hidden: false, mobileTabbar: false, mobileDrawer: false, mobileView: () => import('@/mobile/MobileMyCertificates.vue'), mobileNav: true }
        },
        {
          path: 'courses',
          name: 'memberCourses',
          component: MyCourses,
          meta: { title: '我的课程', hidden: false, mobileTabbar: false, mobileDrawer: false, mobileView: () => import('@/mobile/MobileMyCourses.vue'), mobileNav: true }
        },
        {        
          path: 'collections',
          name: 'memberCollections',
          component: () => import('@/views/myCourses/MyCollections.vue'),
          meta: { title: '我的收藏', hidden: false, mobileTabbar: false, mobileDrawer: false, mobileView: () => import('@/mobile/MobileMyCollections.vue'), mobileNav: true }
        },
        {    
          path: 'distribution-rights',
          name: 'memberDistributionRights',
          component: () => import('@/views/myCourses/DistributionRights.vue'),
          meta: { title: '分销权益', hidden: false, mobileTabbar: false, mobileDrawer: false, mobileView: () => import('@/mobile/MobileDistributionRights.vue'), mobileNav: true }
        },
        {    
          path: 'withdraw',
          name: 'memberWithdraw',
          component: Withdraw,
          meta: { title: '提现', hidden: false, mobileTabbar: false, mobileDrawer: false, mobileView: () => import('@/mobile/MobileWithdraw.vue'), mobileNav: true }
        },
        {    
          path: 'order/:id',
          name: 'memberOrderDetail',
          component: OrderDetail,
          meta: { 
            title: '订单详情', 
            hidden: false, 
            mobileTabbar: false, 
            mobileDrawer: false, 
            mobileNav: true, 
            mobileView: () => import('@/mobile/MobileOrderDetail.vue')
          }
        },
        {
          path: 'classes',
          name: 'memberClasses',
          component: () => import('@/views/myCourses/MyClasses.vue'),
          meta: { title: '我的班级', hidden: false, mobileTabbar: false, mobileDrawer: false, mobileView: () => import('@/mobile/MobileMyClasses.vue'), mobileNav: true }
        },
        {
          path: 'class-study-detail/:id',
          name: 'classStudyDetail',
          component: () => import('@/views/myCourses/ClassStudyDetail.vue'),
          meta: { title: '班级学习详情', hidden: false, mobileTabbar: false, mobileDrawer: false, mobileView: () => import('@/mobile/MobileClassStudyDetail.vue'), mobileNav: true, requiresAuth: true }
        }
      ]
    },
    {
      path: '/exam-plan/:id',
      name: 'examPlanDetail',
      component: isMobile ? MobilePage : ExamPlanDetail,
      meta: { title: '考试计划详情', hidden: false, pcView: ExamPlanDetail, mobileView: () => import('@/mobile/MobileExamPlanDetail.vue'), mobileNav: true }
    },
    {
      path: '/news',
      name: 'newsList',
      component: isMobile ? MobilePage : () => import('@/views/NewsList.vue'),
      meta: { title: '平台动态', hidden: false, pcView: () => import('@/views/NewsList.vue'), mobileView: () => import('@/mobile/MobileNewsList.vue'), mobileNav: true }
    },
    {
      path: '/news/:id',
      name: 'newsDetail',
      component: isMobile ? MobilePage : () => import('@/views/NewsDetail.vue'),
      meta: { title: '新闻详情', hidden: false, pcView: () => import('@/views/NewsDetail.vue'), mobileView: () => import('@/mobile/MobileNewsDetail.vue'), mobileNav: true }
    },
    {
      path: '/standard/:id',
      name: 'standardDetail',
      component: isMobile ? MobilePage : () => import('@/views/StandardDetail.vue'),
      meta: { title: '职业标准详情', hidden: false, pcView: () => import('@/views/StandardDetail.vue'), mobileView: () => import('@/mobile/MobileStandardDetail.vue'), mobileNav: true }
    },
    {
      path: '/teacher/:id',
      name: 'teacherDetail',
      component: isMobile ? MobilePage : () => import('@/views/TeacherDetail.vue'),
      meta: { title: '师资详情', hidden: false, pcView: () => import('@/views/TeacherDetail.vue'), mobileView: () => import('@/mobile/MobileTeacherDetail.vue'), mobileNav: true }
    },
    {
      path: '/student/:id',
      name: 'studentDetail',
      component: isMobile ? MobilePage : () => import('@/views/StudentDetail.vue'),
      meta: { title: '学员详情', hidden: false, pcView: () => import('@/views/StudentDetail.vue'), mobileView: () => import('@/views/StudentDetail.vue'), mobileNav: true }
    },
    {
      path: '/exam-detail/:id',
      name: 'examDetail',
      component: isMobile ? MobilePage : ExamDetail,
      meta: { title: '模拟试卷详情', hidden: false, pcView: ExamDetail, mobileView: () => import('@/mobile/MobileExamDetail.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/exam-intro/:id',
      name: 'examIntro',
      component: isMobile ? MobilePage : ExamIntro,
      meta: { title: '考试说明', hidden: false, pcView: ExamIntro, mobileView: () => import('@/mobile/MobileExamIntro.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/exam-submit-result',
      name: 'examSubmitResult',
      component: isMobile ? MobilePage : ExamSubmitResult,
      meta: { title: '考试已提交', hidden: false, pcView: ExamSubmitResult, mobileView: () => import('@/mobile/MobileExamSubmitResult.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/exam-submit-success',
      name: 'examSubmitSuccess',
      component: isMobile ? MobilePage : ExamSubmitSuccess,
      meta: { title: '考试已提交', hidden: false, pcView: ExamSubmitSuccess, mobileView: () => import('@/mobile/MobileExamSubmitSuccess.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/paper-answer-result',
      name: 'paperAnswerResult',
      component: isMobile ? MobilePage : PaperAnswerResult,
      meta: { title: '答题结果', hidden: false, pcView: PaperAnswerResult, mobileView: () => import('@/mobile/MobileExamSubmitResult.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/answer-record/:id',
      name: 'answer-record',
      component: isMobile ? MobilePage : () => import('@/views/myCourses/PaperAnswerResult.vue'),
      meta: { title: '答题记录', hidden: false, pcView: () => import('@/views/myCourses/PaperAnswerResult.vue'), mobileView: () => import('@/mobile/MobileAnswerRecord.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/practice-detail/:id',
      name: 'practiceDetail',
      component: isMobile ? MobilePage : PracticeDetail,
      meta: { title: '练习试卷详情', hidden: false, pcView: PracticeDetail, mobileView: () => import('@/mobile/MobilePracticeDetail.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/error-notes',
      name: 'errorNotes',
      component: isMobile ? MobilePage : ErrorNotes,
      meta: { title: '错题记录', hidden: false, pcView: ErrorNotes, mobileView: () => import('@/mobile/MobileErrorNotes.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/my-exams',
      name: 'myExams',
      component: isMobile ? MobilePage : MyExams,
      meta: { title: '我的考试', hidden: false, pcView: MyExams, mobileView: () => import('@/mobile/MobileMyExams.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/my-orders',
      name: 'myOrders',
      component: isMobile ? MobilePage : MyOrders,
      meta: { title: '我的订单', hidden: false, pcView: MyOrders, mobileView: () => import('@/mobile/MobileMyOrders.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/coupons',
      name: 'coupons',
      component: isMobile ? MobilePage : Coupons,
      meta: { title: '优惠券', hidden: false, pcView: Coupons, mobileView: () => import('@/mobile/MobileCoupons.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/address',
      name: 'address',
      component: isMobile ? MobilePage : Address,
      meta: { title: '地址管理', hidden: false, pcView: Address, mobileView: () => import('@/mobile/MobileAddress.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/order/:id',
      name: 'orderDetail',
      component: isMobile ? MobilePage : OrderDetail,
      meta: { title: '订单详情', hidden: false, pcView: OrderDetail, mobileView: () => import('@/mobile/MobileOrderDetail.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/physical-payment',
      name: 'physicalPayment',
      component: isMobile ? MobilePage : PhysicalOrderPayment,
      meta: { title: '实物订单支付', hidden: false, pcView: PhysicalOrderPayment, mobileView: () => import('@/mobile/MobilePhysicalPayment.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/simulation',
      name: 'simulation',
      component: isMobile ? MobilePage : Simulation,
      meta: { title: '模拟练习', hidden: false, pcView: Simulation, mobileView: () => import('@/mobile/MobileSimulation.vue'), mobileNav: true, requiresAuth: true }
    },
    {
      path: '/talent-plan-agreement',
      name: 'talentPlanAgreement',
      component: isMobile ? MobilePage : UserAgreement,
      meta: { title: '英才计划用户协议', hidden: false, pcView: UserAgreement, mobileView: () => import('@/mobile/MobileFooterUserAgreement.vue'), mobileNav: true }
    },
    {
      path: '/cart',
      name: 'cart',
      component: isMobile ? MobilePage : Cart,
      meta: { title: '购物车', hidden: false, pcView: Cart, mobileView: () => import('@/mobile/MobileCart.vue'), mobileTabbar: true }
    },
    {
      path: '/cart/checkout',
      name: 'cartCheckout',
      component: isMobile ? MobilePage : CartCheckout,
      meta: { title: '确认订单', hidden: false, pcView: CartCheckout, mobileView: () => import('@/mobile/MobileCartCheckout.vue'), mobileNav: true, requiresAuth: true }
    },
    // Footer routes
    {
      path: '/about-us',
      name: 'aboutUs',
      component: isMobile ? MobilePage : AboutUs,
      meta: { title: '关于我们', hidden: false, pcView: AboutUs, mobileView: () => import('@/mobile/MobileAboutUs.vue'), mobileNav: true }
    },
    {
      path: '/about-talent-plan',
      name: 'aboutTalentPlan',
      component: isMobile ? MobilePage : AboutTalentPlan,
      meta: { title: '关于英才计划', hidden: false, pcView: AboutTalentPlan, mobileView: () => import('@/mobile/MobileAboutTalentPlan.vue'), mobileNav: true }
    },
    {
      path: '/company-qualification',
      name: 'companyQualification',
      component: isMobile ? MobilePage : CompanyQualification,
      meta: { title: '企业资质', hidden: false, pcView: CompanyQualification, mobileView: () => import('@/mobile/MobileCompanyQualification.vue'), mobileNav: true }
    },
    {
      path: '/agreement/:docType',
      name: 'agreementPage',
      component: isMobile ? MobilePage : AgreementPage,
      meta: { title: '协议详情', hidden: false, pcView: AgreementPage, mobileView: () => import('@/mobile/MobileAgreementPage.vue'), mobileNav: true }
    },
    {
      path: '/help-center',
      name: 'helpCenter',
      component: isMobile ? MobilePage : HelpCenter,
      meta: { title: '帮助中心', hidden: false, pcView: HelpCenter, mobileView: () => import('@/mobile/MobileHelpCenter.vue'), mobileNav: true }
    },
    {
      path: '/sitemap',
      name: 'sitemap',
      component: isMobile ? MobilePage : Sitemap,
      meta: { title: '网站地图', hidden: false, pcView: Sitemap, mobileView: () => import('@/mobile/MobileSitemap.vue'), mobileNav: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // 动态修正移动端/PC端组件：如果初始 isMobile 判断有误，在此处修正
  if (shouldBuildMobile) {
    const mobileNow = isMobileDevice()
    to.matched.forEach(record => {
      if (!record.meta) return
      const comp = record.components.default
      if (mobileNow && comp !== MobilePage && record.meta.mobileView) {
        record.components.default = MobilePage
      } else if (!mobileNow && comp === MobilePage && record.meta.pcView) {
        record.components.default = record.meta.pcView
      }
    })
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn()) {
      const redirect = to.fullPath
      if (isMobileDevice()) {
        next({ path: '/mobile-login', query: { redirect } })
      } else {
        try {
          sessionStorage.setItem('auth:login-required', '1')
          sessionStorage.setItem('auth:login-redirect', redirect)
        } catch (e) { /* ignore */ }
        window.dispatchEvent(new CustomEvent('auth:login-required', { detail: { redirect } }))
        next(false)
      }
      return
    }
  }
  next()
})

export default router
